import MainButton from 'components/MainButton';
import Layout from 'Layout'
import React from 'react'
import CardNewsSecondary from 'components/CardNewsSecondary';
import SecondaryButton from 'components/SecondaryButton';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { useCallback } from 'react';
import { getBerita, getBeritaByKategori, getBeritaPopuler, getKategoriBerita, searchBerita } from 'services/apiRoutes';
import { useEffect } from 'react';
import SkeletonCardNewsSecondary from 'skeletons/SkeletonCardNewsSecondary';
import cx from 'classnames';
import ImNews from 'assets/images/ImNews1.jpg'
import HorizontalCard from 'components/HorizontalCard';

export default function Berita() {
  const {slug}=useParams();
  const [berita,setBerita]= useState();
  const [counter, setCounter] = useState(1);
  const [total,setTotal]=useState();
  const [populer,setPopuler]= useState();
  const [totalPopuler,setTotalPopuler]=useState();
  const cardNewsClasses = cx({
    "md:grid grid-rows-2 grid-flow-col gap-4 mt-12 space-y-5 md:space-y-0":
      totalPopuler > 3 ? true : false,
  });
  const [loading,setLoading] = useState(false);
  const[active,setActive]=useState();
  const[defaultKategori,setDefaultKategori]=useState(true);


  const [kategori, setKategori] = useState();
  const [keyword, setKeyword] = useState();

  const beritaAPI = useCallback(async(limit,offset)=>{
    setLoading(true);
    const res = await getBerita(limit, offset,slug);
    if (res.error) {
      return res.message;
    }else{
      const {data} = res.data;
      const { jumlahData } = res.data;
      setTotal(jumlahData)
      setActive(null);
      setBerita(data);
      setLoading(false);
      setDefaultKategori(true);

    }
  },[slug])

  const beritaPopulerAPI = useCallback(async(limit,offset)=>{
    setLoading(true);
    const res = await getBeritaPopuler(limit, offset,slug);
    if (res.error) {
      return res.message;
    }else{
      const {data} = res.data;
      const {jumlahData} = res.data;
      setTotalPopuler(jumlahData);
      setPopuler(data);
      setLoading(false);
    }
  },[slug])

      const beritaKategoriAPI = useCallback(async () => {
        const res = await getKategoriBerita(slug);
        if (res.error) {
          return res.message;
        } else {
          const { data } = res.data;
          setKategori(data);
        }
      }, [slug]);

          const beritaByKategoriAPI = useCallback(async (uuid,indexBtn) => {
            setLoading(true);
            const res = await getBeritaByKategori(20, 0, uuid,slug);
            if (res.error) {
              return res.message;
            } else {
              setLoading(false);
              const { data } = res.data;
              setBerita(data);
              setActive(indexBtn);
              setDefaultKategori(false);
            }
          }, [slug]);

  const handleLoad = () => {
    setCounter(counter+3);
  }


     const searchKegAPI = useCallback(async (limit, offset, keyword) => {
       setLoading(true);
       const res = await searchBerita(limit, offset, keyword,slug);
       if (res.error) {
         return res.message;
       } else {
         setLoading(false);
         const { data } = res.data;
         setBerita(data);
       }
     }, [slug]);

     const seacrhNews = () => {
       searchKegAPI(100, 0, keyword);
     };

     const handleKeypress = (e) => {
       if (e.key === "Enter") {
         searchKegAPI(100, 0, keyword);
       }
     };

  useEffect(() => {
    beritaPopulerAPI(3, 0);
    beritaAPI(counter, 0);
    beritaKategoriAPI();
  }, [beritaAPI, beritaKategoriAPI, beritaPopulerAPI,counter,keyword]);

  const navigate = useNavigate();
  return (
    <Layout active="berita">
      <div className="px-5 xl:pt-44 pt-28 kegiatan-wrapper xl:px-99">
        <h1 className="text-2xl font-bold xl:mb-20 mb-14 xl:text-7xl">
          Berita Gampong
        </h1>
        <div className="space-y-24 wrapperCad">
          <HorizontalCard
            // desc="90% Masyarakat Gampong Geulanggang teungoh adalah Petani"
            title="Berita Gampong"
            img={ImNews}
          />
        </div>
        <div className="mt-[78px] font-bold text-sm">Cari berita:</div>
        <input
          type="text"
          placeholder="Cari berita"
          onChange={(e) => setKeyword(e.target.value)}
          onKeyPress={handleKeypress}
          className="px-5 py-3 my-4 border seacrh rounded-2xl focus:outline-none xl:w-[994px] mr-4 w-full focus:ring-2 focus:ring-primary focus:border-none"
        />
        <MainButton label="Cari" onClick={() => seacrhNews()} />
        {berita?.length !== 0 ? null : (
          <h1 className="font-bold">{`"${keyword}" Tidak Ditemukan`}</h1>
        )}
        <div className="flex mt-[78px] items-center space-x-6 overflow-x-scroll xl:overflow-x-hidden">
          <div className="text-sm font-bold">Filter</div>
          {kategori
            ? kategori.map((item, index) => (
                <MainButton
                  activeBtn={active === index ? true : false}
                  secondType
                  label={item.nama}
                  key={index && item.uuid}
                  onClick={() => beritaByKategoriAPI(item.uuid, index)}
                />
              ))
            : null}
          <MainButton
            secondType
            label="Semua"
            activeBtn={defaultKategori}
            onClick={() => beritaAPI(counter, 0)}
          />
        </div>
        {/* <div className="grid-cols-2 mt-24 space-y-5 xl:space-y-0 xl:grid xl:space-x-5 main-wrapper"> */}
        <div className={cardNewsClasses}>
          {!loading ? (
            populer?.map((item, index) =>
              index <= 2 && index === 0 ? (
                  <div className="col-span-3 row-span-2">
                    <CardNewsSecondary
                      gallery
                      onClick={() =>
                        navigate(`/${slug}/postberita/${item.uuid}`)
                      }
                      img={item ? item?.url_gambar : ""}
                      label={
                        item?.list_kategori_berita_obj[0]?.kategori_obj?.nama
                      }
                      title={item?.judul}
                      post={item.create_date}
                    />
                  </div>
              ) : (
                <div className="col-span-2">
                    <CardNewsSecondary
                      // h={300}
                      gallery
                      onClick={() =>
                        navigate(`/${slug}/postberita/${item.uuid}`)
                      }
                      img={item ? item?.url_gambar : ""}
                      label={
                        item?.list_kategori_berita_obj[0]?.kategori_obj?.nama
                      }
                      title={item?.judul}
                      post={item.create_date}
                    />
                </div>
              )
            )
          ) : (
            <div className="mt-5">
              <SkeletonCardNewsSecondary />
            </div>
          )}
        </div>
        <h1 className="mt-24 font-bold mb-7">Berita Terbaru</h1>
        <div className="w-full mb-16 space-y-10 horizontal-news">
          {!loading ? (
            berita?.map((item, index) => (
              <CardNewsSecondary
                gallery
                key={index}
                onClick={() => navigate(`/${slug}/postberita/${item.uuid}`)}
                img={item ? item?.url_gambar : ""}
                label={item?.list_kategori_berita_obj[0]?.kategori_obj?.nama}
                h={300}
                title={item?.judul}
                post={item.create_date?.substring(0, 11)}
              />
            ))
          ) : (
            <SkeletonCardNewsSecondary />
          )}
        </div>
        <div className="flex items-center justify-center py-32 loadMore">
          {counter >= total ? (
            <h1 className="font-bold">Sudah mentok!</h1>
          ) : (
            <SecondaryButton
              label="Lebih Banyak"
              onClick={() => handleLoad()}
              loading={loading}
            />
          )}
        </div>
      </div>
    </Layout>
  );
}
